import { List } from 'react-admin'
import ResourceListHeader from '../components/ResourceListHeader'
import ActivityDatagrid from './ActivityDatagrid'

const ActivityList = () => (
  <>
    <ResourceListHeader resource="activities" />
    {/* Clinical timeline: default to newest-first by start_time, matching the
        dashboard's activity views. Without this, react-admin defaults to id ASC. */}
    <List sort={{ field: 'start_time', order: 'DESC' }}>
      <ActivityDatagrid />
    </List>
  </>
)

export default ActivityList
